export const feelings = [
  { id: "exp1", face: "💪", feeling: "accomplished" },
  { id: "exp2", face: "😠", feeling: "aggravated" },
  { id: "exp3", face: "😀", feeling: "alive" },
  { id: "exp4", face: "😔", feeling: "alone" },
  { id: "exp5", face: "😯", feeling: "amazed" },
  { id: "exp6", face: "🤩", feeling: "amazing" },
  { id: "exp7", face: "🙂", feeling: "amused" },
  { id: "exp8", face: "😡", feeling: "angry" },
  { id: "exp9", face: "😠", feeling: "annoyed" },
  { id: "exp10", face: "😓", feeling: "anxious" },
  { id: "exp11", face: "😃", feeling: "awesome" },
  { id: "exp12", face: "😖", feeling: "awful" },
  { id: "exp13", face: "🙁", feeling: "bad" },
  { id: "exp14", face: "😉", feeling: "beautiful" },
  { id: "exp15", face: "😉", feeling: "better" },
  { id: "exp16", face: "😛", feeling: "blah" },
  { id: "exp17", face: "😇", feeling: "blessed" },
  { id: "exp18", face: "😕", feeling: "bored" },
  { id: "exp19", face: "😫", feeling: "broken" },
  { id: "exp20", face: "😌", feeling: "chill" },
  { id: "exp21", face: "🥶", feeling: "cold" },
  { id: "exp22", face: "😊", feeling: "comfortable" },
  { id: "exp23", face: "😎", feeling: "confident" },
  { id: "exp24", face: "🙄", feeling: "confused" },
  { id: "exp25", face: "😊", feeling: "content" },
  { id: "exp26", face: "😏", feeling: "cool" },
  { id: "exp27", face: "😩", feeling: "crappy" },
  { id: "exp28", face: "🤯", feeling: "crazy" },
  { id: "exp29", face: "🤔", feeling: "curious" },
  { id: "exp30", face: "😔", feeling: "depressed" },
  { id: "exp31", face: "😀", feeling: "determined" },
  { id: "exp32", face: "😞", feeling: "disappointed" },
  { id: "exp33", face: "😞", feeling: "down" },
  { id: "exp34", face: "😬", feeling: "drained" },
  { id: "exp35", face: "🥴", feeling: "drunk" },
  { id: "exp36", face: "😂", feeling: "ecstatic" },
  { id: "exp37", face: "😭", feeling: "emotional" },
  { id: "exp38", face: "🤩", feeling: "energized" },
  { id: "exp39", face: "🤩", feeling: "excited" },
  { id: "exp40", face: "😔", feeling: "exhausted" },
  { id: "exp41", face: "😝", feeling: "fantastic" },
  { id: "exp42", face: "😃", feeling: "fat" },
  { id: "exp43", face: "😄", feeling: "free" },
  { id: "exp44", face: "😆", feeling: "fresh" },
  { id: "exp45", face: "😬", feeling: "frustrated" },
  { id: "exp46", face: "😊", feeling: "full" },
  { id: "exp47", face: "😂", feeling: "funny" },
  { id: "exp48", face: "😊", feeling: "good" },
  { id: "exp49", face: "😊", feeling: "grateful" },
  { id: "exp50", face: "😊", feeling: "great" },
  { id: "exp51", face: "😔", feeling: "guilty" },
  { id: "exp52", face: "😊", feeling: "happy" },
  { id: "exp53", face: "😰", feeling: "heartbroken" },
  { id: "exp54", face: "😰", feeling: "helpless" },
  { id: "exp55", face: "😊", feeling: "hopeful" },
  { id: "exp56", face: "😢", feeling: "hopeless" },
  { id: "exp57", face: "😭", feeling: "horrible" },
  { id: "exp58", face: "🥵", feeling: "hot" },
  { id: "exp59", face: "🤤", feeling: "hungry" },
  { id: "exp60", face: "😢", feeling: "hurt" },
  { id: "exp61", face: "😡", feeling: "impatient" },
  { id: "exp62", face: "🥰", feeling: "in love" },
  { id: "exp63", face: "😬", feeling: "incomplete" },
  { id: "exp64", face: "😇", feeling: "inspired" },
  { id: "exp65", face: "😒", feeling: "irritated" },
  { id: "exp66", face: "😴", feeling: "lazy" },
  { id: "exp67", face: "😞", feeling: "lonely" },
  { id: "exp68", face: "😵", feeling: "lost" },
  { id: "exp69", face: "🥰", feeling: "loved" },
  { id: "exp70", face: "🥰", feeling: "lovely" },
  { id: "exp71", face: "😎", feeling: "lucky" },
  { id: "exp72", face: "🤬", feeling: "mad" },
  { id: "exp73", face: "🙄", feeling: "meh" },
  { id: "exp74", face: "😩", feeling: "miserable" },
  { id: "exp75", face: "🧐", feeling: "motivated" },
  { id: "exp76", face: "😨", feeling: "nervous" },
  { id: "exp77", face: "🥺", feeling: "nostalgic" },
  { id: "exp78", face: "🙂", feeling: "OK" },
  { id: "exp79", face: "🙂", feeling: "old" },
  { id: "exp80", face: "😇", feeling: "optimistic" },
  { id: "exp81", face: "😫", feeling: "overwhelmed" },
  { id: "exp82", face: "🤕", feeling: "pained" },
  { id: "exp83", face: "😡", feeling: "pissed" },
  { id: "exp84", face: "🤬", feeling: "pissed off" },
  { id: "exp85", face: "😊", feeling: "positive" },
  { id: "exp86", face: "🥰", feeling: "pretty" },
  { id: "exp87", face: "😎", feeling: "proud" },
  { id: "exp88", face: "😉", feeling: "pumped" },
  { id: "exp89", face: "😄", feeling: "ready" },
  { id: "exp90", face: "😊", feeling: "refreshed" },
  { id: "exp91", face: "😙", feeling: "relaxed" },
  { id: "exp92", face: "😌", feeling: "relieved" },
  { id: "exp93", face: "😩", feeling: "rough" },
  { id: "exp94", face: "😞", feeling: "sad" },
  { id: "exp95", face: "😉", feeling: "safe" },
  { id: "exp96", face: "😚", feeling: "satisfied" },
  { id: "exp97", face: "😬", feeling: "scared" },
  { id: "exp98", face: "😎", feeling: "sexy" },
  { id: "exp99", face: "😲", feeling: "shocked" },
  { id: "exp100", face: "🤢", feeling: "sick" },
  { id: "exp101", face: "🤪", feeling: "silly" },
  { id: "exp102", face: "😴", feeling: "sleepy" },
  { id: "exp103", face: "🤕", feeling: "sore" },
  { id: "exp104", face: "😔", feeling: "sorry" },
  { id: "exp105", face: "🥳", feeling: "special" },
  { id: "exp106", face: "😥", feeling: "stressed" },
  { id: "exp107", face: "😊", feeling: "strong" },
  { id: "exp108", face: "🙄", feeling: "stupid" },
  { id: "exp109", face: "🤩", feeling: "super" },
  { id: "exp110", face: "😮", feeling: "surprised" },
  { id: "exp111", face: "😔", feeling: "terrible" },
  { id: "exp112", face: "😊", feeling: "thankful" },
  { id: "exp113", face: "😓", feeling: "tired" },
  { id: "exp114", face: "😑", feeling: "uncomfortable" },
  { id: "exp115", face: "🙃", feeling: "upset" },
  { id: "exp116", face: "😟", feeling: "weak" },
  { id: "exp117", face: "🤓", feeling: "weird" },
  { id: "exp118", face: "😚", feeling: "well" },
  { id: "exp119", face: "🥰", feeling: "wonderful" },
  { id: "exp120", face: "😥", feeling: "worried" },
];
